import { apiClient } from '../config';

const base = '/announcements';

const announcementList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.data)) return payload.data;
  console.warn('Unexpected announcements response:', payload);
  return [];
};

export const announcementService = {
  getPublic: async () => announcementList((await apiClient.get(`${base}/public`)).data),
  getPublicById: async (id) => (await apiClient.get(`${base}/public/${id}`)).data,
  list: async (params = {}) => (await apiClient.get(base, { params })).data,
  getById: async (id) => (await apiClient.get(`${base}/${id}`)).data,
  create: async (data) => (await apiClient.post(base, data)).data,
  update: async (id, data) => (await apiClient.put(`${base}/${id}`, data)).data,
  publish: async (id) => (await apiClient.post(`${base}/${id}/publish`)).data,
  schedule: async (id, publishAt, expiresAt) => (
    await apiClient.post(`${base}/${id}/schedule`, { publishAt, expiresAt })
  ).data,
  unpublish: async (id) => (await apiClient.post(`${base}/${id}/unpublish`)).data,
  archive: async (id) => (await apiClient.post(`${base}/${id}/archive`)).data,
  restore: async (id) => (await apiClient.post(`${base}/${id}/restore`)).data,
  remove: async (id) => apiClient.delete(`${base}/${id}`),
  uploadFlyer: async (id, file, onUploadProgress) => {
    const data = new FormData();
    data.append('flyer', file);
    return (await apiClient.post(`${base}/${id}/flyer`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    })).data;
  },
  deleteFlyer: async (id) => (await apiClient.delete(`${base}/${id}/flyer`)).data,
  addAttachments: async (id, files, onUploadProgress) => {
    const data = new FormData();
    files.forEach(file => data.append('attachments', file));
    return (await apiClient.post(`${base}/${id}/attachments`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    })).data;
  },
  deleteAttachment: async (id, attachmentId) => (
    await apiClient.delete(`${base}/${id}/attachments/${attachmentId}`)
  ).data,
};

export const announcementAssetUrl = (url) => {
  if (!url || url.startsWith('http')) return url;
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
  return `${apiUrl.replace(/\/api\/?$/, '')}${url}`;
};
